export default "__VITE_ASSET__36f4fedf__"